import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-dialogue',
  templateUrl: './confirmation-dialogue.component.html',
  styleUrls: ['./confirmation-dialogue.component.scss']
,
  standalone: false
})
export class ConfirmationDialogueComponent implements OnInit {
  @Input('data') _data: any;
  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
